/**
 * The sections of the "how we calculate" chapter of the manual. They live here, next to the
 * explanation component, because the (i) balloon of a number links straight INTO its
 * section: the anchor is part of the explanation, not a detail of the page that renders it.
 */
export const COMO_CALCULAMOS_PATH = '/ajuda';

/**
 * The chapter is a tab of the Ajuda page, which also holds a card per SCREEN with ids of
 * its own (`#fila`, `#mapa`). The prefix keeps the two sets of anchors apart, so a link
 * always lands on the tab that owns it.
 */
export const COMO_CALCULAMOS_ANCORA_PREFIXO = 'calculo-';

/** The subjects in the order the chapter reads them, which is also the index's. */
export const COMO_CALCULAMOS_SECOES = [
  'prazo',
  'capacidade',
  'fontes',
  'maquinaParada',
  'celulaDoDia',
  'balanceamento',
  'polivalencia',
  'curadoria',
  'fila',
  'simulador',
  'mapa',
  'visaoExecutiva',
  'relatorios',
] as const;

export type TComoCalculamosSecao = (typeof COMO_CALCULAMOS_SECOES)[number];

/** The id of one section's card, which is also the hash that opens it. */
export function comoCalculamosAncora(secao: TComoCalculamosSecao): string {
  return `${COMO_CALCULAMOS_ANCORA_PREFIXO}${secao}`;
}

/** The link a balloon points to: the manual opens already scrolled to that section. */
export function comoCalculamosHref(secao: TComoCalculamosSecao): string {
  return `${COMO_CALCULAMOS_PATH}#${comoCalculamosAncora(secao)}`;
}
